"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = exports.Svg = exports.SvgWrapper = exports.TopLine = exports.BottomLine = exports.AnimatedLine = exports.Line = exports.StyledMenu = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledMenu = styled_components_1.default.div `
  margin: auto 1.25rem auto auto;

  cursor: pointer;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    margin: auto ${({ theme }) => theme.space.s400} auto auto;
  }
`;
exports.Line = styled_components_1.default.line `
  fill: none;
  opacity: ${({ isOpen }) => (isOpen ? 0 : 1)};
  stroke: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.text.body)};
  stroke-miterlimit: 10;
  stroke-width: 2px;
  transition: all ease-in-out 100ms;
`;
exports.AnimatedLine = (0, styled_components_1.default)(exports.Line) `
  opacity: 1;
  transform-origin: 0 0;
  transition: 100ms ease-in-out;
`;
exports.BottomLine = (0, styled_components_1.default)(exports.AnimatedLine) `
  transform: ${({ isOpen }) => (isOpen ? 'rotate(-45deg) translate(-15px)' : 'none')};
`;
exports.TopLine = (0, styled_components_1.default)(exports.AnimatedLine) `
  transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg) translate(6px, -9px)' : 'none')};
`;
exports.SvgWrapper = styled_components_1.default.div `
  width: 30px;
  height: 30px;
`;
exports.Svg = styled_components_1.default.svg `
  > * {
    height: 100%;
  }
`;
exports.StyledLabel = styled_components_1.default.div `
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    display: block;

    color: ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.text.body)};

    ${({ theme }) => (0, styled_components_1.css)(Object.assign(Object.assign({}, theme.typography.body.tinyTextMain), { fontWeight: theme.typography.body.regularTextMain.fontWeight }))};

    transition: all ease-in-out 100ms;
  }
`;
